module.exports = __webpack_public_path__ + "static/media/19.e818403c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/19.png
// module id = 1124
// module chunks = 0